import React, { useState, useEffect, useRef } from 'react';
import { basic, validationMessages, wholeNumber } from '../../../config/validations';
import { Controller, useForm } from "react-hook-form";
import { Grid, TextField, MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import UpdateCancel from '../../atoms/buttons/UpdateCancel';
import { toggleRightDrawer, setDisablePan, setFocusElement, toggleBottomDrawer } from '../../../store/global/actions';
import { getConstructType } from '../../../config/common';
import { getBottomDrawerStatus, getElementOnFocus, getRightDrawerStatus } from '../../../store/global/selectors';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { invokePostService, invokeGetService, setReRender, setInnerScreenRender, setHeaderName, handleSnackBar, setDisabled } from "../../../store/global/actions";
import { useParams } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { generateMongoId, validateNonAsciiChars } from '../../../utils/commonUtils';
import SkeletonLoader from '../../atoms/loader/SkeletonLoader';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import { UtilityFunctionDialog } from '../utility_functions/UtilityFunctionDialog';
import { getDetailsFromUrl } from '../../../services/blueprint';
const uuid = require('short-uuid');


export default function EditTransaction({ element, onCreateInvokedTransaction }) {
    const [isInvoked, setIsInvoked] = useState(false);
    const category = useRef('');
    const params = useParams();
    const currentUrl = window.location.href;
    const history = useHistory();
    const { slug, blueprintId, entityId } = getDetailsFromUrl();

    const filter = createFilterOptions();


    const dispatch = useDispatch();
    const elementOnFocus = useSelector(getElementOnFocus);
    const isBottomDrawerOpen = useSelector(getBottomDrawerStatus);
    const rightDrawerStatus = useSelector(getRightDrawerStatus);

    let updatedTransactionId = null;

    const [selectedTransactionId, setSelectedTransactionId] = useState(element?.id);
    const [transactions, setTransactions] = useState([]);
    const [transaction, setTransaction] = useState(null);
    const [behaviour, setBehaviour] = useState(null);
    const [oneof, setOneof] = useState('');
    const [condition, setCondition] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [showChildTypeSelection, setShowChildTypeSelection] = useState(false);
    const [showChildBehaviorAttributes, setShowChildBehaviorAttributes] = useState(false);
    const [childType, setChildType] = useState("new");
    const [transactionToInvoke, setTransactionToInvoke] = useState(null);
    const [transactionOptions, setTransactionOptions] = useState([]);
    const [utilityFunctions, setUtilityFunctions] = useState([]);
    const [loopValue, setLoopValue] = useState(null);
    const [openUtilityFunctionDialog, setOpenUtilityFunctionDialog] = useState(false);
    const [selectedUtilityFunction, setSelectedUtilityFunction] = useState(null);

    const handleChildBehaviourChange = (event) => {
        if (event.target.value === 'noneofthese' || event.target.value === "")
            setBehaviour('noneofthese')
        else
            setBehaviour(event.target.value);
    }

    const handleChildTypeChange = (event) => {
        if (event.target.value === 'new')
            setChildType(event.target.value);
        else {
            setShowChildBehaviorAttributes(true);
            setChildType(event.target.value);
        }
    }


    const { register, handleSubmit, formState: { errors }, setValue, control, setError, clearErrors } = useForm({
        defaultValues: {
            name: transaction?.name,
            description: transaction?.description,
            selectTransactionToInvoke: "", // add default for the new field
            oneof,
            loop: transaction?.loop,
            condition,
            section: transaction?.section,
            version: transaction?.version,
            timeout: transaction?.timeout,
            spec: transaction?.spec,
            optional: transaction?.optional,
            onerror: transaction?.onerror
        }
    });


    const messages = {
        ...validationMessages,
        validate: 'Duplicate transaction name given'
    }



    const getTransactionAssociates = (selectedTransactionId) => {

        const transactionPromise = dispatch(invokeGetService('getTransactionAssociates', [selectedTransactionId]));
        const utilitiesPromise = dispatch(invokeGetService('getAllUtilityFunctions', []));

        Promise.all([transactionPromise, utilitiesPromise])
            .then(([transactionResponse, utilitiesResponse]) => {
                setLoading(false);
                let modifiedUtilityFunctions = [];
                if (utilitiesResponse.status && utilitiesResponse.data) {
                    const sortedUtilityFunctions = utilitiesResponse.data.filter(item => item.name).sort((a, b) => a.name.localeCompare(b.name));
                    modifiedUtilityFunctions = sortedUtilityFunctions.map(item => ({ title: item.name, value: item._id.toString() }));
                    setUtilityFunctions(modifiedUtilityFunctions);
                }


                if (transactionResponse?.data?.transaction !== undefined) {
                    let selectTrans = transactionResponse.data?.transaction;

                    setTransaction(selectTrans);
                    setTransactionOptions(transactionResponse?.data?.allTransaction?.filter(item => item?._id !== params?.transaction && item?.type === 7));
                    setValue('name', selectTrans?.name)
                    setValue('description', selectTrans?.description)
                    setValue('version', selectTrans?.version)
                    setValue('spec', selectTrans?.spec)
                    setValue('timeout', selectTrans?.timeout)
                    setValue('section', selectTrans?.section)
                    setTransactions(transactionResponse.data.allTransaction);
                    setBehaviour(selectTrans?.oneof ? 'oneof' : selectTrans?.loop ? 'loop' : selectTrans?.condition ? 'condition' : 'noneofthese');
                    setValue('onerror', selectTrans?.onerror)
                    if (transactionResponse.data.transaction.events.length === 0 && transactionResponse.data.transaction.nestedTransactions.length === 0) {
                        dispatch(setDisabled(true))
                    } else {
                        dispatch(setDisabled(false))
                    }

                    if (getConstructType(element.type) === 'nested_transaction') {

                        if (selectTrans?.events?.length === 0) setShowChildTypeSelection(true);
                        setShowChildBehaviorAttributes(true);
                        setIsInvoked(false);
                        setOneof(selectTrans?.oneof)
                        setCondition(selectTrans?.condition)
                        setValue('oneof', selectTrans?.oneof)
                        setValue('condition', selectTrans?.condition)
                        setValue('optional', selectTrans?.optional)
                        setValue('timeout', selectTrans.timeout)
                        setValue('behaviourField', "oneof")
                        const utilityFuncion = modifiedUtilityFunctions.find(item => item.value === selectTrans?.loop);
                        setLoopValue(utilityFuncion);

                    }

                    if (getConstructType(element.type) === 'invoked_transaction' && element.id !== params.transaction && element.type !== 9) {
                        setIsInvoked(true);
                        let mainTrans = transactionResponse.data?.allTransaction.find(maintr => maintr._id === params.transaction)
                        let invokedTrans = mainTrans?.invokedTransactions.find(invk => invk.id === element.id)

                        setShowChildBehaviorAttributes(true);
                        setBehaviour(invokedTrans?.oneof ? 'oneof' : invokedTrans?.loop ? 'loop' : invokedTrans?.condition ? 'condition' : 'noneofthese');
                        setOneof(invokedTrans?.oneof);
                        setCondition(invokedTrans?.condition);
                        setValue('oneof', invokedTrans?.oneof);
                        setValue('condition', invokedTrans?.condition);
                        const utilityFuncion = modifiedUtilityFunctions.find(item => item.value === invokedTrans?.loop);

                        setLoopValue(utilityFuncion);
                    }

                    if (element.id === elementOnFocus.id && elementOnFocus.category !== undefined) {
                        category.current = elementOnFocus.category;
                    }

                } else if (!transactionResponse?.status && transactionResponse?.code === 255 && transactionResponse.transactionNotFound === true) {
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    if (isBottomDrawerOpen) dispatch(toggleBottomDrawer());
                }


            })
    }



    const duplicateTransaction = (field) => {
        let result = transactions.find(t => t.name === field && t.id !== transaction.id);
        return result === undefined ? true : false;
    }

    const onCancel = () => {
        dispatch(setDisablePan(false));
        dispatch(toggleRightDrawer());
    }



    const onUpdate = async (data) => {
        setIsEditing(true);
        let updateStatus = false;
        console.log("data---", data)
        console.log("loopValue---", loopValue)
        let { name, description, condition, behaviourField } = data;
        behaviourField = behaviourField ? behaviourField : behaviour;

        let editTransaction = {
            ...transaction,
            name,
            description
        }

        // Behavioural attributes for child/invoked transaction
        let behaviourAttrbutesForChild = {}
        if (getConstructType(element.type) === 'nested_transaction' || isInvoked) {
            if (behaviourField === 'oneof') {
                behaviourAttrbutesForChild.condition = null;
                behaviourAttrbutesForChild.loop = null;
                behaviourAttrbutesForChild.oneof = true;
            } else if (behaviourField === 'loop') {
                behaviourAttrbutesForChild.oneof = false;
                behaviourAttrbutesForChild.condition = null;
                behaviourAttrbutesForChild.loop = loopValue?.value || "";
            } else if (behaviourField === 'condition') {
                behaviourAttrbutesForChild.oneof = false;
                behaviourAttrbutesForChild.loop = null;
                behaviourAttrbutesForChild.condition = condition;
            } else if (behaviourField === 'noneofthese') { //temp code to allow the users to uncheck - to be optimized
                behaviourAttrbutesForChild.oneof = false;
                behaviourAttrbutesForChild.loop = null;
                behaviourAttrbutesForChild.condition = null;
            }
        }


        // CREATE INVOKED TRANSACTION
        if (getConstructType(element.type) === 'nested_transaction' && childType === "invoke_transaction") {
            setLoading(true);
            const newUUID = uuid.generate();
            const payload = {
                selectedChild: element?.id,
                parentTransaction: element?.parent,
                transactionId: elementOnFocus?.transaction,
                invokeId: transactionToInvoke?._id,
                invokeData: { ...behaviourAttrbutesForChild },
                uuid: newUUID
            }
            if (onCreateInvokedTransaction) onCreateInvokedTransaction({ data: { id: element?.id, parent: element?.parent, invokedTxnId: transactionToInvoke?._id, uuid: newUUID } });

            await dispatch(invokePostService('createInvokedTransaction', payload, []))
                .then((response) => {
                    if (response.status && response.data) {
                        setIsEditing(false)
                        updatedTransactionId = transactionToInvoke?._id;
                        setSelectedTransactionId(transactionToInvoke?._id);
                        const focusItem = {
                            transaction: elementOnFocus?.transaction,
                            id: transactionToInvoke?._id,
                            name: transactionToInvoke?.name,
                            desc: transactionToInvoke?.desc || "",
                            type: "invoked_transaction",
                            item: transactionToInvoke,
                            action: "edit"
                        }
                        dispatch(setFocusElement(focusItem));
                        dispatch(handleSnackBar({ open: true, message: 'Child transaction updated', severity: 'success' }));
                        dispatch(setReRender());


                    } else if (response?.status === false && response.errors !== undefined && response.errors.length > 0) {
                        if (onCreateInvokedTransaction) onCreateInvokedTransaction({ status: false });

                        if (response?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                            response?.errors?.forEach(error => {
                                setError(error?.name, { message: error.message });
                            });
                        }
                        setIsEditing(false);
                    } else {
                        if (onCreateInvokedTransaction) onCreateInvokedTransaction({ status: false });
                        setIsEditing(false);
                        dispatch(handleSnackBar({ open: true, message: response?.message ? response?.message : 'Configuring child as invoked transation failed', severity: 'error' }));
                    }

                    dispatch(setReRender());
                    setLoading(false);
                }).catch(error => {
                    console.error("Updating child transaction to invoked transaction failed .", error);
                    setLoading(false);
                })


            return;
        }


        // UPDATE CHILD TRANSACTION
        if (getConstructType(element.type) === 'nested_transaction') {
            editTransaction = { ...editTransaction, ...behaviourAttrbutesForChild };
            await dispatch(invokePostService('updateNestedTransaction', { nestedData: editTransaction }, [element.id]))
                .then((response) => {
                    if (response.status && response.data) {
                        updateStatus = true
                        setIsEditing(false);
                        dispatch(setReRender());
                        dispatch(handleSnackBar({ open: true, message: 'Child transaction updated', severity: 'success' }));
                    } else if (response?.status === false && response.errors !== undefined && response.errors.length > 0) {
                        if (response?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                            response?.errors?.forEach(error => {
                                setError(error?.name, { message: error.message });
                            });
                        }
                        setIsEditing(false)
                    } else {
                        setIsEditing(false)
                        dispatch(handleSnackBar({ open: true, message: response?.message ? response?.message : 'Update child transaction failed', severity: 'error' }));
                    }
                }).catch(error => {
                    console.error("Updating child transaction failed. ", error);
                })

            // UPDATE INVOKED TRANSACTION
        } else if (isInvoked) {

            const payload = { invokedData: { ...behaviourAttrbutesForChild }, invokeId: element.id };
            await dispatch(invokePostService('updateInvokedTransaction', payload, [params.transaction]))
                .then((response) => {
                    if (response.status && response.data) {
                        updateStatus = true
                        dispatch(setReRender());
                        setIsEditing(false)
                        dispatch(handleSnackBar({ open: true, message: 'Invoked transaction updated', severity: 'success' }));
                    } else {
                        setIsEditing(false)
                        dispatch(handleSnackBar({ open: true, message: response?.message ? response?.message : 'Update invoked transaction failed', severity: 'error' }));
                    }

                })
                .catch(error => {
                    console.error(`Updating invoked transaction failed. ${error}`);
                    dispatch(handleSnackBar({ open: true, message: 'Update invoked transaction failed', severity: 'error' }));
                })

            // UPDATE MAIN TRANSACTION
        } else {
            await dispatch(invokePostService('updateTransactionInfo', { transaction: editTransaction }, [params.transaction]))
                .then((response) => {
                    if (response.status) {
                        updateStatus = true
                        dispatch(setInnerScreenRender());
                        dispatch(setReRender());
                        // dispatch(setHeaderName(editTransaction?.name));
                        dispatch(handleSnackBar({ open: true, message: `Transaction updated`, severity: "success" }));
                        setIsEditing(false)
                    } else if (response?.status === false && response?.code === 255 && response.transactionNotFound === true) {
                        updateStatus = false;
                        dispatch(setInnerScreenRender());
                        dispatch(setFocusElement(null));
                        history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    }

                })
        }

        if (updateStatus) {
            dispatch(setFocusElement({ transaction: editTransaction._id, id: editTransaction._id, type: getConstructType(element.type), name: editTransaction?.name ? editTransaction?.name : element?.name }))
        }

        // dispatch(reRenderInfoBuilder());
        if (process.env.REACT_APP_AUTO_CLOSE === 'true' && rightDrawerStatus) {
            dispatch(toggleRightDrawer());
        }
    }

    const handleSelectTransactionChange = (value) => {
        const selectedTransaction = transactionOptions?.find(txn => txn?._id === value);
        setTransactionToInvoke(selectedTransaction);
    }


    useEffect(() => {
        setLoading(true)
        if (selectedTransactionId !== null) getTransactionAssociates(updatedTransactionId ? updatedTransactionId : selectedTransactionId);
    }, [selectedTransactionId]);

    const createUtilityFunction = (id, name) => {
        const utilityFunction = {
            _id: id,
            name: name,
            body: "",
            parameters: [{ name: "instance" }, { name: "transaction" }, { name: "message" }, { name: "msgsrc" }],
            type: 10,
        };
        setSelectedUtilityFunction(utilityFunction);
        setUtilityFunctions((prev) => [...prev, { title: name, value: id }]);
        dispatch(invokePostService("createUtilityFunction", { utilityFunction }, []))
            .then(response => {
                if (!response.status) {
                    setUtilityFunctions((prev) => prev.filter(item => item.value != id));
                    dispatch(handleSnackBar({ open: true, message: `Utility function creation failed`, severity: "error" }));
                } else {
                    dispatch(setInnerScreenRender());
                }
            });
    }

    const handleCloseUtilityFunctonDialog = () => {
        setOpenUtilityFunctionDialog(false);
    }

    const loopValidation = (value, utilityFunctions = []) => {
        if (!value || value.trim() === "") {
            return "Function name is required";
        }

        if (!/^[a-zA-Z_]\w*/.test(value)) {
            return "Invalid function name";
        }

        const fnName = value.split("(")[0].trim();
        if (utilityFunctions.some((f) => f.name === fnName)) {
            return "Function name already exists";
        }

        return true;
    };


    const handleCreateFunction = (inputValue) => {
        const validation = loopValidation(inputValue, utilityFunctions);
        if (validation !== true) {
            setError("loop", { message: validation });
            return;
        }
        clearErrors("loop");
        const id = generateMongoId();
        createUtilityFunction(id, inputValue);
        setLoopValue({
            title: inputValue,
            value: id
        });
        setOpenUtilityFunctionDialog(true);
    }


    return (
        <>
            {isLoading ?
                <SkeletonLoader rows={2} />
                :
                <Grid id={"edit_transaction_form"} container direction={"row"} spacing={3} style={{ paddingTop: 10 }}>

                    {/* Radio buttons for choosing a invoke transaction */}
                    {showChildTypeSelection &&
                        <Grid item xs={12} >
                            <Grid id={"transaction_type_label"} item xs={12}>Transaction type</Grid>
                            <Controller
                                control={control}
                                rules={{ required: false }}
                                name={`select_child_type`}
                                defaultValue={childType}
                                render={({ onChange, value, ...rest }) => {
                                    return (
                                        <>
                                            <RadioGroup id={"transaction_type_radio_group"} aria-label="select_child_type" style={{ flexDirection: 'row' }} name="select_child_type" value={childType} onChange={e => { handleChildTypeChange(e); onChange(e); }}>
                                                <FormControlLabel value="new" control={<Radio id={"radio_create_new"} color="#364150" />} label="New" />
                                                <FormControlLabel value="invoke_transaction" control={<Radio id={"radio_invoke_transaction"} color="#364150" />} label="Invoke transaction" />
                                            </RadioGroup>
                                        </>
                                    );
                                }}
                            />
                        </Grid>}

                    {/* List transactions to select for invoking */}
                    {showChildTypeSelection && childType === "invoke_transaction" && (
                        <Grid item xs={12} >
                            <TextField
                                id={"select-transaction-menu"}
                                select
                                name={"selectTransactionToInvoke"}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                label="Transaction"
                                required
                                placeholder="Select"
                                onChange={(e) => { setValue("selectTransactionToInvoke", e.target.value); handleSelectTransactionChange(e.target.value) }}
                                // value={transactionToInvoke?._id || ""}
                                SelectProps={{ native: true, }}
                                variant="outlined"
                                inputRef={register({
                                    required: "Please select a transaction to invoke",
                                    validate: value => value !== "" || "Please select a transaction to invoke",
                                })}
                                error={!!errors.selectTransactionToInvoke}
                                helperText={errors.selectTransactionToInvoke ? errors.selectTransactionToInvoke?.message : ""}
                            >
                                <option key={"empty"} value={""}> Choose </option>
                                {transactionOptions?.map((option) => (
                                    <option id={`option-${option.name}`} key={option._id} value={option._id}>{option.name}</option>
                                ))}
                            </TextField>
                        </Grid>
                    )}

                    {childType !== "invoke_transaction" &&
                        <Grid item xs={12} style={{ display: 'flex', gap: "1rem" }}>
                            <Grid item xs={12}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    name="name"
                                    autoFocus={true}
                                    fullWidth
                                    type={"text"}
                                    required={true}
                                    label={"Name"}
                                    variant="outlined"
                                    placeholder={""}
                                    disabled={isInvoked}
                                    inputRef={register({ ...basic, validate: duplicateTransaction })}
                                    error={errors?.name ? true : false}
                                    helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                                />
                            </Grid>
                        </Grid>}


                    {!isInvoked && childType !== "invoke_transaction" && <Grid item xs={12}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            type={"text"}
                            fullWidth
                            multiline={true}
                            rows={4}
                            label={"Description"}
                            variant="outlined"
                            name="description"
                            inputRef={register({ required: false, validate: validateNonAsciiChars })}
                            error={errors.description}
                            helperText={errors.description ? errors?.description?.message : ''}
                        />
                    </Grid>}



                    {showChildBehaviorAttributes &&
                        <Grid id={"attributes_container"} item xs={4} >
                            <TextField id="attributes" label="Attributes" select variant="outlined" fullWidth value={behaviour} onChange={e => { handleChildBehaviourChange(e) }}>
                                <MenuItem id={"menu-item-Select"} key={1} value={"noneofthese"}>Select</MenuItem>
                                <MenuItem id={"menu-item-condition"} value="condition">Condition</MenuItem>
                                {!isInvoked && childType !== "invoke_transaction" && <MenuItem id={"menu-item-oneof"} value="oneof">Oneof</MenuItem>}
                                <MenuItem id={"menu-item-loop"} value="loop">Loop</MenuItem>
                            </TextField>
                        </Grid>
                    }


                    {/* Condition */}
                    {showChildBehaviorAttributes && behaviour === 'condition' && <Grid item xs={8}>
                        <TextField
                            name="condition"
                            fullWidth
                            type={"text"}
                            required={true}
                            label={"Condition"}
                            variant="outlined"
                            placeholder={""}
                            InputLabelProps={{ shrink: true }}
                            error={errors?.condition ? true : false}
                            inputRef={register({ required: true })}
                            helperText={Boolean(errors.condition) ? validationMessages[errors?.condition?.type] : ""}
                        />
                    </Grid>}

                    {/* Loop function name */}
                    {showChildBehaviorAttributes && behaviour === 'loop' && <Grid item xs={8}>
                        <Autocomplete
                            value={loopValue}
                            onChange={(event, newValue) => {
                                if (typeof newValue === 'string') {
                                    // User directly typed and hit enter
                                    const duplicateFunction = utilityFunctions.find(item => item.title === newValue);
                                    if (duplicateFunction) {
                                        setLoopValue(duplicateFunction);
                                    } else {
                                        handleCreateFunction(newValue);
                                    }
                                } else if (newValue && newValue.inputValue) {
                                    // User selected "Create new function ..."
                                    handleCreateFunction(newValue.inputValue);
                                } else {
                                    // User selected from list
                                    setLoopValue(newValue);
                                }
                            }}
                            filterOptions={(options, params) => {
                                const filtered = filter(options, params);
                                if (params.inputValue !== '' && !filtered.some(item => item.title === params.inputValue)) {
                                    filtered.unshift({
                                        inputValue: params.inputValue,
                                        title: `Create new utility function '${params.inputValue}'`,
                                    });
                                }
                                return filtered;
                            }}
                            selectOnFocus
                            clearOnBlur
                            handleHomeEndKeys
                            id="loop"
                            options={utilityFunctions}
                            getOptionLabel={(option) => {
                                if (typeof option === 'string') {
                                    return option;
                                }
                                if (option.inputValue) {
                                    return option.inputValue;
                                }
                                return option.title;
                            }}
                            renderOption={(option) => option.title}
                            freeSolo
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    name="loop"
                                    required
                                    label="Loop Function Name"
                                    variant="outlined"
                                    fullWidth
                                    placeholder={utilityFunctions.length === 0 ? "No functions found. Type to create one" : "Specify the function name"}
                                    error={Boolean(errors?.loop)}
                                    helperText={
                                        errors?.loop?.message ? errors?.loop?.message : ""
                                    }
                                    inputRef={register({ required: "Loop Function Name is required" })}
                                />
                            )}
                        />
                    </Grid>
                    }



                    {/* Update and cancel buttons */}
                    <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                        <UpdateCancel onUpdate={handleSubmit(onUpdate)} onCancel={onCancel} updateDisable={isEditing || isLoading} content={isEditing ? 'Updating..' : isLoading ? 'Loading...' : 'Update'} />
                    </Grid>

                </Grid>}

            {openUtilityFunctionDialog && <UtilityFunctionDialog handleClose={handleCloseUtilityFunctonDialog} setSelectedUtilityFunction={setSelectedUtilityFunction} selectedUtilityFunction={selectedUtilityFunction} />}


        </>
    )
}